import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyLabel", "yearlyLabel", "saveLabel"]

  connect() {
    this.isYearly = false
  }

  toggle() {
    this.isYearly = !this.isYearly
    this.element.dataset.pricingYearly = this.isYearly

    this.monthlyLabelTarget.classList.toggle("text-black", !this.isYearly)
    this.monthlyLabelTarget.classList.toggle("text-[#959494]", this.isYearly)
    this.yearlyLabelTarget.classList.toggle("text-black", this.isYearly)
    this.yearlyLabelTarget.classList.toggle("text-[#959494]", !this.isYearly)

    this.element.querySelectorAll(".monthly-price").forEach(el => {
      el.classList.toggle("hidden", this.isYearly)
    })
    this.element.querySelectorAll(".yearly-price").forEach(el => {
      el.classList.toggle("hidden", !this.isYearly)
    })

    const dot = this.element.querySelector('[data-pricing-toggle-target="dot"]')
    if (dot) {
      dot.classList.toggle("translate-x-5", this.isYearly)
      dot.classList.toggle("translate-x-0", !this.isYearly)
    }

    this.saveLabelTarget.classList.toggle("bg-gradient-to-r", this.isYearly)
    this.saveLabelTarget.classList.toggle("from-[#fc4c02]", this.isYearly)
    this.saveLabelTarget.classList.toggle("via-[#ef2cc1]", this.isYearly)
    this.saveLabelTarget.classList.toggle("to-[#bdbbff]", this.isYearly)
    this.saveLabelTarget.classList.toggle("bg-clip-text", this.isYearly)
    this.saveLabelTarget.classList.toggle("text-transparent", this.isYearly)
    this.saveLabelTarget.classList.toggle("text-[#959494]", !this.isYearly)

    this.element.querySelectorAll('form.button_to input[name="interval"]').forEach(input => {
      // 后端只认 "annual"（checkouts_controller / BillingPlans.price_id_for），不能传 "yearly"
      input.value = this.isYearly ? "annual" : "monthly"
    })
  }
}
